import { useHistory, useLocation } from "react-router-dom";
import { useGetBreakpoints } from "../../hooks/useGetBreakpoints";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import {
  isArrayNonEmpty,
  isValidElement,
  isValidString,
} from "../../util/ApiHelper";
import { fetchStart, fetchSuccess } from "../../appRedux/actions";
import { axiosInstance, BASE_API_CONFIG } from "../../util/Api";
import { formatDate, getNewLine } from "../../util/helper";
import EnquiryStatusTags from "../../admin/enquiries/EnquiriesStatus";
import { Button, Card, Image, List, Modal } from "antd";
import { CloseOutlined, LeftOutlined } from "@ant-design/icons";
import SubscriptionPlans from "../subscriptionPlan/subscriptionPlan";

const OfferProductsView = () => {
  const history = useHistory();
  const { isMobile } = useGetBreakpoints();
  const dispatch = useDispatch();
  const location = useLocation();
  const isFromUserProfile = location.state?.isFromUserProfile;
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const id = urlParams.get("id");
  const [productData, setProductData] = useState(null);
  const [fileName, setFileName] = useState("");
  const [subscriptionData, setSubscriptionData] = useState(null);
  const isSubscribed = [2, 3].includes(subscriptionData?.subscription?.planId);
  const userData = useSelector(({ auth }) => auth?.userData);
  const userId = userData.id;
  const [showSubscriptionPlans, setShowSubscriptionPlans] = useState(false);
  const [userDatas, setUserDatas] = useState(userData);
  useEffect(() => {
    const fetchSubscription = async () => {
      try {
        const response = await axiosInstance.get(
          `${BASE_API_CONFIG.baseURL}/subscription-plans/user/${userId}`
        );
        setSubscriptionData(response.data);
      } catch (err) {
        console.error("Subscription fetch error:", err);
      }
    };
    fetchSubscription();
  }, [userId]);
  const handleCloseSubscriptionPlans = () => {
    setShowSubscriptionPlans(false);
  };

  const getProductById = async (id) => {
    if (isValidString(id)) {
      dispatch(fetchStart());
      try {
        const productById = await axiosInstance.get(
          `${BASE_API_CONFIG.baseURL}/offer-products/exporters/${id}`
        );
        setProductData(productById?.data);
      } catch (error) {
        console.error("Error fetching product:", error);
      } finally {
        dispatch(fetchSuccess());
      }
    }
  };
  useEffect(() => {
    getProductById(id);
  }, [id]);

  useEffect(() => {
    const images = productData?.data?.primaryImage;
    if (Array.isArray(images)) {
      setFileName(images);
    } else if (typeof images === "string" && images) {
      setFileName([{ src: images }]);
    }
  }, [productData]);

  const navigateBusinessCard = (id) => {
    if (id) {
      history.push(`/user-profile?id=${id}`);
    }
  };
  const styles = {
    closeButton: {
      position: "absolute",
      top: "10px",
      right: "10px",
      fontSize: "20px",
      fontWeight: "bold",
      background: "#ffffff",
      border: "1px solid #e8e8e8",
      borderRadius: "50%",
      width: "32px",
      height: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
      zIndex: 1000,
    },
  };
  const data = [
    {
      label: "Posted Date",
      value: formatDate(productData?.data?.createdAt),
    },
    {
      label: "Company Name",
      value: (
        <div>
          <div
            style={{
              filter: !(subscriptionData?.isActive && isSubscribed)
                ? "blur(4px)"
                : "none",
              display: "inline-block",
            }}
          >
            {productData?.data?.user.companyName || "N/A"}
          </div>
          <br />
          {!(subscriptionData?.isActive && isSubscribed) && (
            <span
              style={{ color: "#1890ff", cursor: "pointer", marginLeft: "8px" }}
              onClick={() => setShowSubscriptionPlans(true)}
            >
              Upgrade to view company name
            </span>
          )}
          <span
            onClick={() => navigateBusinessCard(productData?.data.user?.id)}
            className={"myexim-link "}
          >
            View Profile
          </span>
        </div>
      ),
    },
    {
      label: "Product Name",
      value: productData?.data?.name,
    },
    {
      label: "Quantity Available",
      value: `${productData?.data?.qty} ${productData?.data?.uom}`,
    },
    {
      label: "Offer Price",
      value: `INR ${productData?.data?.price} / ${productData?.data?.uom}`,
    },
    {
      label: "Payment Terms",
      value: productData?.data?.paymentTerms,
    },
    {
      label: "Comments",
      value: productData?.data?.comments,
    },
  ];

  return (
    isValidElement(productData) && (
      <>
        <Card className="myexim-detail-card">
          <div className="myexim-table-title">
            <div>
              <LeftOutlined
                // className={"back-icon"}
                style={{ fontSize: "20px", color: "#434E5B" }}
                size="large"
                onClick={() => {
                  history.goBack();
                }}
              />
            </div>
            Offer Product Details
          </div>
          <div
            className={`logo-with-list gx-mt-4 ${
              isMobile ? "gx-flex-column" : ""
            }`}
          >
            <div style={{ paddingRight: 16 }}>
              {isValidString(productData?.primaryImage) && (
                <div className={"logo-container"}>
                  <div className={"logo-image"}>
                    <img
                      alt="..."
                      src={productData?.primaryImage}
                      width={isMobile ? "100%" : 120}
                      height={isMobile ? "100%" : 120}
                    />
                  </div>
                </div>
              )}
            </div>
            <div style={{ flex: 1 }}>
              <List
                itemLayout="horizontal"
                dataSource={data}
                renderItem={(item) =>
                  item?.value && (
                    <List.Item className="myexim-details-list">
                      <List.Item.Meta
                        title={<div>{item.label}</div>}
                        description={
                          isValidString(item.value) ? item.value : "-"
                        }
                      />
                    </List.Item>
                  )
                }
              />
              {fileName?.length > 0 && (
                <div className="attachments gx-mt-3">
                  <div className="sub-header ">Attachments</div>
                  <div className="gx-mt-4">
                    Please find the below attachment as a reference
                  </div>
                  <div className="gx-pt-4">
                    {fileName?.map((fileName, index) => (
                      <div key={index} className="gx-pb-3">
                        <Image
                          className="gx-rounded-lg"
                          width={isMobile ? "100%" : 150}
                          height={isMobile ? "100%" : 150}
                          src={fileName?.src}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </Card>

        <Modal
          visible={showSubscriptionPlans}
          onCancel={handleCloseSubscriptionPlans}
          closeIcon={<CloseOutlined style={styles.closeButton} />}
          footer={null}
          width={800}
        >
          <SubscriptionPlans
            userDatas={userDatas}
            setUserDatas={setUserDatas}
          />
        </Modal>
      </>
    )
  );
};
export default OfferProductsView;
